export default __webpack_public_path__ + "static/media/img_teams_create.ed32bace.png";